import { useState } from "react";
import { EditSvg } from "../../../icons";
import CreateOurStory from "../../../pages/tv-app/home/our-story/create-our-story";
import { IVideos } from "../../../utils/types";
import classNames from "classnames";

interface EditOfferProps {
  data: IVideos | null;
  showIcon?: boolean;
  Icon?: any;
  defaultOpen?: boolean;
  onClose?: () => void;
  isDraftEditOffer?: boolean;
  disabled?: boolean;
  createNew?: boolean;
  isEditVideo?: boolean;
}
const EditOurStory: React.FC<EditOfferProps> = ({
  data,
  showIcon = true,
  Icon,
  defaultOpen = false,
  onClose,
  isDraftEditOffer,
  disabled,
  createNew = false,
  isEditVideo= false,
}) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(defaultOpen);

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    onClose?.();
  };

  return (
    <>
      {showIcon ? (
        Icon ? (
          <div onClick={disabled ? undefined : openModal}>{Icon}</div>
        ) : (
          <div
            onClick={disabled ? undefined : openModal}
            className={classNames(
              "h-8 w-8 rounded-full bg-[#EFF6FF] flex items-center justify-center hover:bg-[#DBEAFE] transition-colors",
              disabled ? "opacity-50" : "cursor-pointer"
            )}
          >
            <EditSvg color="#6362E7" />
          </div>
        )
      ) : null}
      <CreateOurStory
        videoData={data!}
        isEditVideo={isEditVideo}
        onSuccess={() => closeModal()}
        isOpen={isModalOpen}
        closeModal={closeModal}
        modalTitle={`Edit Our Story`}
      />
      {/* </div>
      </Modal> */}
    </>
  );
};

export default EditOurStory;
